import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default class extends Controller {
  static targets = ["images","products", "circleBtn"]

  initialize() {
    this.currentIndex = 0
    this.previousIndex = this.currentIndex
    this.images = this.imagesTarget.querySelectorAll('li')
    this.products = this.productsTarget.querySelectorAll('li')
    this.collectionsTotal = this.images.length - 1
    this.setupTimelines()
  }

  setupTimelines(){
    this.circleBtnTargets.forEach((target)=>{
      const svgs = target.querySelectorAll('svg'),
      arrowSvg = target.querySelectorAll('svg')[0]

      const hoverTL = gsap.timeline({
        paused: true
      })
      .to(arrowSvg,{
        xPercent:200,
        duration:.25,
        autoAlpha:0
      },'start')
      .set(arrowSvg,{
        xPercent:-200,
        duration:.25,
        autoAlpha:1
      })
      .to(arrowSvg,{
        xPercent:0,
        duration:.25
      })

      target.addEventListener("mouseenter", ()=>{
        if(!target.classList.contains('disabled')){
          if (!hoverTL.isActive()) {
            hoverTL.progress(0).play()
          }
        }
      });
      target.addEventListener("click", ()=>{
        if(!target.classList.contains('disabled')){
          if (!hoverTL.isActive()) {
            hoverTL.progress(0).play()
          }
        }
      });
    })
  }

  prevImage(event){
    event.preventDefault()

    if(!event.target.closest('a').classList.contains('disabled')){

      this.previousIndex = this.currentIndex
      if(this.currentIndex == 0){
        this.currentIndex = this.collectionsTotal
      }else{
        this.currentIndex = this.currentIndex - 1
      }

    }


    this.handleAction()
  }

  nextImage(event){
    event.preventDefault()

    if(!event.target.closest('a').classList.contains('disabled')){
      this.previousIndex = this.currentIndex
      if(this.currentIndex == this.collectionsTotal){
        this.currentIndex = 0
      }else{
        this.currentIndex = this.currentIndex + 1
      }
  
      this.handleAction()
    }

  }

  handleAction(){
    gsap.timeline({
      onStart:()=>{
        this.circleBtnTargets.forEach((target)=>{
          target.classList.add('disabled')
        })
      },
      onComplete:()=>{
        this.circleBtnTargets.forEach((target)=>{
          target.classList.remove('disabled')
        })
      }
    })
    .to(this.images[this.previousIndex],{
      autoAlpha:0,
      duration:.125
    },'previousFade')
    .to(this.products[this.previousIndex],{
      autoAlpha:0
    },'previousFade')
    .set(this.images[this.previousIndex],{
      'display': 'none'
    },'previousHide')
    .set(this.products[this.previousIndex],{
      'display': 'none'
    },'previousHide')
    .to(this.images[this.currentIndex],{
      autoAlpha:1,
      duration:.125,
      'display': 'block'
    },'current')
    .to(this.products[this.currentIndex],{
      autoAlpha:1,
      duration:.125,
      'display': 'block'
    },'current')
  }

  disconnect(){
    // this.hide()
  }
}